import React from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';

import { getEntityOwnershipText } from 'common/utility/helpers';
import { makeFullAddressDisplay } from '@utilityprofit/address-helpers';

import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrDividerLine from 'client/components/SrDividerLine';
import { createFormValidationFn, createInitialValues } from 'client/helpers/formikHelpers';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_RED,
} from 'client/components/SrButton/SrButton';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

const formFields = [
  {
    id: 'cancelReasonOther',
    type: 'long_text',
    properties: {
      placeholder: 'Reason for archiving',
    },
    validations: ['required'],
  },
];

const SrUtilityActivationCancelModal = ({ onClose, onSubmit, activation }) => {
  const tenantName = activation.user?.firstName;
  const address = makeFullAddressDisplay(activation.address);
  const title = tenantName
    ? `Archiving ${getEntityOwnershipText({ name: tenantName, word: 'Utilities' })}`
    : 'Archiving Utilities';

  return (
    <SrDarkModal onClose={onClose}>
      <SrModalContent style={{ width: 553, marginTop: 4 }}>
        <SrBox display="flex" alignItems="center" justifyContent="center" flexDirection="column">
          <SrText
            font="greycliff"
            fontSize="26px"
            weight="800"
            lineHeight="36px"
            letterSpacing="0.5"
          >
            {title}
          </SrText>
        </SrBox>
        <SrDividerLine text={address} alignItems="center" />
        <SrFlex marginTop="8px">
          <Formik
            initialValues={createInitialValues({
              formFields: formFields,
              defaultValues: {
                cancelReason: '',
              },
            })}
            validate={(formValues) => {
              return createFormValidationFn(formFields)(formValues);
            }}
            onSubmit={onSubmit}
            render={(formikBag) => {
              return (
                <Form style={{ width: '100%' }}>
                  <SrBox margin="20px 0">
                    {formFields.map((formField) => {
                      return (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                          className={SR_FIELD_THEME_ADOBE}
                        />
                      );
                    })}
                  </SrBox>
                  <SrBox className="submitButtonContainer">
                    <SrButton
                      theme={SR_BUTTON_THEME_ADOBE_RED}
                      onClick={formikBag.submitForm}
                      disabled={!formikBag.isValid}
                    >
                      Archive
                    </SrButton>
                    <SrButton
                      theme={SR_BUTTON_THEME_ADOBE_GREY}
                      margin="12px 0px"
                      onClick={onClose}
                    >
                      Cancel
                    </SrButton>
                  </SrBox>
                </Form>
              );
            }}
          />
        </SrFlex>
      </SrModalContent>
    </SrDarkModal>
  );
};

SrUtilityActivationCancelModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  activation: PropTypes.object.isRequired,
};

export default SrUtilityActivationCancelModal;
